import { useState } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import StepShell from "../StepShell";
import TimeRangePicker from "@/components/flow/properties/TimeRangePicker";

const OUT_OF_HOURS = [
  { id: "collect_and_promise", label: "Bot coleta tudo e avisa que retornam no horário" },
  { id: "inform_hours", label: "Apenas informa o horário de atendimento" },
];

export const DEFAULT_HOURS = {
  windows: [
    {
      conditions: [
        { type: "weekdays", days: ["mon", "tue", "wed", "thu", "fri"] },
        { type: "time", start: "09:00", end: "18:00" },
      ],
    },
  ],
  timezone: "America/Sao_Paulo",
};

/**
 * Horário de atendimento humano + comportamento fora do horário. Reusa o mesmo
 * editor dinâmico de janelas dos nós do fluxo.
 */
export default function LeadsHorario({ briefing, autosave }) {
  const leadHandling = briefing.leadHandling || {};
  const [hours, setHours] = useState(leadHandling.serviceHours || DEFAULT_HOURS);
  const [behavior, setBehavior] = useState(
    leadHandling.outOfHours?.behavior || "collect_and_promise",
  );

  function persist(patch) {
    autosave({
      leadHandling: {
        ...leadHandling,
        serviceHours: patch.hours ?? hours,
        outOfHours: { behavior: patch.behavior ?? behavior },
      },
    });
  }

  return (
    <StepShell
      title="Qual o horário de atendimento humano?"
      description="Dentro deste horário a IA pode transferir para a equipe. Fora dele, você escolhe o que acontece."
    >
      <div className="space-y-6">
        <div>
          <Label className="mb-2 block">Horário de atendimento</Label>
          <TimeRangePicker
            value={hours}
            onChange={(next) => {
              setHours(next);
              persist({ hours: next });
            }}
          />
        </div>

        <div>
          <Label className="mb-2 block">Fora do horário</Label>
          <div className="space-y-2">
            {OUT_OF_HOURS.map((o) => (
              <RadioRow
                key={o.id}
                active={behavior === o.id}
                onClick={() => {
                  setBehavior(o.id);
                  persist({ behavior: o.id });
                }}
                label={o.label}
              />
            ))}
          </div>
        </div>
      </div>
    </StepShell>
  );
}

function RadioRow({ active, onClick, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex w-full items-center gap-3 rounded-xl border p-3 text-left text-sm transition-colors",
        active
          ? "border-cyan-500/60 bg-cyan-500/[0.06] text-foreground"
          : "border-border bg-surface text-muted-foreground hover:border-border-strong",
      )}
    >
      <span
        className={cn(
          "flex h-4 w-4 items-center justify-center rounded-full border",
          active ? "border-cyan-500" : "border-border",
        )}
      >
        {active && <span className="h-2 w-2 rounded-full bg-cyan-500" />}
      </span>
      {label}
    </button>
  );
}
